export default {
  title: "Roles",
  subtitle: "Manage user roles and permissions",
  
  addNew: "Add New Role",
  createRole: "Create Role",
  editRole: "Edit Role",
  deleteRole: "Delete Role",
  
  fields: {
    name: "Role Name",
    description: "Description",
    permissions: "Permissions",
    isActive: "Active",
    level: "Access Level",
    status: "Status",
    createdAt: "Created At",
    updatedAt: "Updated At",
    permissionIds: "Permission IDs"
  },
  
  placeholders: {
    name: "Enter role name",
    description: "Enter role description",
    level: "Select access level"
  },
  
  messages: {
    createSuccess: "Role created successfully",
    createError: "Failed to create role",
    updateSuccess: "Role updated successfully",
    updateError: "Failed to update role",
    deleteSuccess: "Role deleted successfully",
    deleteError: "Failed to delete role",
    deleteConfirm: "Are you sure you want to delete this role?",
    noRoles: "No roles found",
    loadingRoles: "Loading roles...",
    loadingPermissions: "Loading permissions...",
    fetchError: "Failed to fetch roles"
  },
  
  validation: {
    nameRequired: "Role name is required",
    nameMinLength: "Role name must be at least 2 characters",
    nameMaxLength: "Role name must not exceed 50 characters",
    descriptionMaxLength: "Description must not exceed 200 characters",
    permissionsRequired: "At least one permission is required",
    fillAllFields: "Please fill in all required fields"
  },
  
  table: {
    name: "Name",
    description: "Description",
    permissions: "Permissions",
    level: "Level",
    status: "Status",
    actions: "Actions"
  },
  
  levels: {
    admin: "Administrator",
    manager: "Manager",
    user: "User",
    guest: "Guest"
  },
  
  statusOptions: {
    active: "Active",
    inactive: "Inactive"
  },
  
  breadcrumbs: {
    roles: "Roles",
    create: "Create Role",
    edit: "Edit Role",
    view: "View Role"
  },

  buttons: {
    submit: "Submit",
    update: "Update",
    submitting: "Submitting...",
    updating: "Updating...",
    backToIndex: "Back to Index"
  }
};
